<app-window [title]="title">
    <div class="row">
        <div class="col-md-4 col-lg-3">
            <select class="form-control form-select alert-primary d-block d-md-none mb-3" #tabSelect (change)="tab=tabSelect.value">
                <option value=0 *ngIf="!checkPermission('showOnlyDataSection')">Generalità</option>
                <option value=5>Dati</option>
                <option value=6 *ngIf="!checkPermission('showOnlyDataSection')">Operatori</option>
                <option value=1 *ngIf="!checkPermission('showOnlyDataSection')">Cronologia</option>
                <option value=2 *ngIf="!checkPermission('showOnlyDataSection')">Allarmi</option>
                <option value=3 *ngIf="!checkPermission('showOnlyDataSection')">Files</option>
                <option value=4 *ngIf="!checkPermission('showOnlyDataSection')">Notes</option>                
            </select>
            <ul class="nav nav-pills flex-column d-none d-md-flex" id="myTab" role="tablist">
                <li *ngIf="!checkPermission('showOnlyDataSection')">
                    <a class="nav-link border pt-2" [class.active]="tab==0" (click)="tab=0">
                        <i class="far fa-clipboard"></i><span class="d-none d-sm-inline-block ml-2">Generalità</span></a>
                </li>
                <li>
                    <a class="nav-link border pt-2" [class.active]="tab==5" (click)="tab=5">
                        <i class="fas fa-tasks"></i><span class="d-none d-sm-inline-block ml-2">Dati</span>
                    </a>
                    <ul class="nav nav-pills flex-column ml-3" *ngIf="tab==5">
                        <ng-container *ngFor="let p of record.phases;let i=index;">
                            <ng-container *ngIf="p.status==1">
                                <li class="nav-link border text-xs" [class.alert-primary]="tab_phase==i" [class.font-weight-bold]="tab_phase==i" (click)="id_section=getFirstIdSection(p.id);tab_phase=i;">                                   
                                    <i [title]="'da avviare'" *ngIf="getPhaseStatus(p.id,p)==0" class="text-gray fa fa-exclamation-circle"></i>
                                    <i [title]="'in corso'"  *ngIf="getPhaseStatus(p.id,p)==1" class="text-warning far fa-clock" ></i>
                                    <i [title]="'completata'" *ngIf="getPhaseStatus(p.id,p)==2" class="text-primary fa fa-check"></i>
                                    <i [title]="'annullata'" *ngIf="getPhaseStatus(p.id,p)==3"  class="text-danger fa fa-times"></i>
                                    <i [title]="'verificata'" *ngIf="getPhaseStatus(p.id,p)==4" class="text-success fa fa-check-double"></i>
                                    <span pageScroll href="#{{p.id}}" class="ml-2" >{{p.title}}</span>
                                    <i *ngIf="tab_phase==i" class="fa fa-chevron-right float-right"></i>
                                </li>
                            </ng-container>
                        </ng-container>
                    </ul>
                </li>
                <li class="nav-item" *ngIf="!checkPermission('showOnlyDataSection')">
                    <a class="nav-link border pt-2" [class.active]="tab==6" (click)="tab=6">
                        <i class="fa fa-users"></i><span class="d-none d-sm-inline-block mx-2">Operatori</span>
                        <!-- <div *ngIf="record.username"  class="bg-purple rounded-circle d-inline-flex align-items-center justify-content-center border text-uppercase" 
                            style="height:1.5rem; width:1.5rem; margin: 0 0.1rem" title="{{record.username}} ">{{record.username[0]}}</div> -->
                         <ng-container *ngFor="let u of record.users;let i=index">
                            <div *ngIf="u.name && u.show" class="rounded-circle d-inline-flex align-items-center justify-content-center border text-uppercase" 
                                style="height:1.5rem; width:1.5rem; margin: 0 0.1rem" title="{{u.name}} ">
                                {{u.name[0]}}</div>
                         </ng-container>
                        
                    </a>
                </li>
                <li class="nav-item" *ngIf="!checkPermission('showOnlyDataSection')">
                    <a class="nav-link border pt-2" [class.active]="tab==1" (click)="tab=1">
                        <i class="far fa-clock"></i><span class="d-none d-sm-inline-block ml-2">Cronologia</span></a>
                </li>
                <li class="nav-item" *ngIf="!checkPermission('showOnlyDataSection')">
                    <a class="nav-link border pt-2" [class.active]="tab==2" (click)="tab=2">
                        <i class="far fa-bell"></i><span class="d-none d-sm-inline-block ml-2">Allarmi <small *ngIf="record.errors && record.errors.length>0">
                            <span class="badge badge-danger">{{record.errors.length}}</span></small></span></a>
                </li>
                <li class="nav-item" *ngIf="!checkPermission('showOnlyDataSection')">
                    <a class="nav-link border pt-2" [class.active]="tab==3" (click)="tab=3">
                        <i class="fas fa-paperclip"></i><span class="d-none d-sm-inline-block ml-2">Files</span>
                            <!-- <span class="badge badge-warning" *ngIf="record.files && record.files.length>0">{{record.files.length}}</span> --></a>
                </li>    
                <li class="nav-item" *ngIf="!checkPermission('showOnlyDataSection')">
                    <a class="nav-link border pt-2" [class.active]="tab==4" (click)="tab=4">
                        <i class="far fa-sticky-note"></i><span class="d-none d-sm-inline-block ml-2">Note</span>
                            <!-- <span class="badge badge-warning" *ngIf="record.files && record.files.length>0">{{record.files.length}}</span> --></a>
                </li>
               
            </ul>
        </div>
        <div class="col-md-8 col-lg-9">
            <div class="" >
                <div class="tab-content" id="myTabContent">
        
                    <!-- GENERALE -->
                    <div class="tab-pane fade show active" *ngIf="tab==0">
                        <form role="form" id="detailForm" *ngIf="record">
                            <div class="row">
                                <div class="col-lg-6">
                                    <div class="row">
                                        <div class="col-lg-6">
                                            <app-type [id_type]="record.id_type" [table]="'dossier'" [record]="record" [showAll]="checkPermission('allowManageType')"></app-type>
                                        </div>
                                        <div class="col-lg-6">
                                            <div class="form-group">
                                                <label>Codice</label>
                                                <div class="input-group input-group-sm">                                            
                                                    <input  class="form-control form-control-sm" type="text" placeholder="" name="code"  [(ngModel)]="record.code"  />    
                                                    <!-- <div class="input-group-append input-group-append-sm" *ngIf="user.isAdmin()">
                                                        <button type="button" class="btn btn-sm btn-default" title="Suggerisci" (click)="true"><i class="fa fa-wizard"></i></button>
                                                    </div> -->
                                                    <!-- <div class="input-group-append input-group-append-sm">
                                                        <button type="button" class="btn btn-sm btn-default" title="Suggerisci" (click)="true"><i class="fas fa-hat-wizard"></i></button>
                                                    </div> -->
        
                                                </div>
                                            </div>
                                        </div>
                                        <!-- <div class="col-lg-6">
                                            <div class="form-group">
                                                <label>Stato</label>
                                                <select class="form-control form-control-sm" name="state" [(ngModel)]="record.state">
                                                    <option value="0">da avviare</option>
                                                    <option value="1">In corso</option>
                                                    <option value="2">Completata</option>
                                                    <option value="3">Annullata</option>
                                                    <option value="4">Verificata</option>
                                                    <option value="5">In attesa</option>
                                                    <option value="6">Archiviata</option>
                                                </select>
                                            </div>
                                        </div> -->                                       
                                         <div class="col-lg-6" *ngIf="user.isAdmin()">
                                            <div class="form-group">
                                                <label>Data inizio</label>
                                                <div class="input-group input-group-sm">                                            
                                                    <input  class="form-control form-control-sm" type="datetime-local" name="date" [(ngModel)]="record.date"  />
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-lg-6" *ngIf="user.isAdmin()">
                                            <div class="form-group">
                                                <label>Data fine</label>
                                                <div class="input-group input-group-sm">                                            
                                                    <input  class="form-control form-control-sm" type="datetime-local" name="date_end" [(ngModel)]="record.date_end"  />
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-lg-12" *ngIf="user.isSuperUser()">
                                            <div class="form-group">
                                                <label>Fase</label>
                                                <select class="form-control form-control-sm" name="id_current_phase" [(ngModel)]="record.id_current_phase">
                                                    <option *ngFor="let p of record.phases" [ngValue]="p.id">{{p.title}}</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-6">
                                    <label>Cliente</label>
                                    <div class="card small-box mb-0">
                                        <app-selectfieldcustom (OnExplore)="selectAddress()" (OnRecordSelected)="OnSelectAddress($event)" (OnRecordView)="OnViewAddress($event)"
                                            [showViewButton]="true"
                                            [showSearchButton]="true"
                                            [recordSelected]="record.addressItem"
                                            [service]="addressesService"
                                            [fieldRender]="'name'"
                                            [class]="'form-control form-control-sm'"></app-selectfieldcustom>
                                        <div class="p-1" *ngIf="record.addressItem && record.addressItem.id>0">
                                            <small>
                                                <div class="row">
                                                    <div class="col-lg-6">
                                                        <small>
                                                            <ng-container *ngIf="record.addressItem.address || record.addressItem.city">
                                                                <b>INDIRIZZO:</b><br>
                                                                {{record.addressItem.address}}<br>
                                                                {{record.addressItem.zip}} {{record.addressItem.city}} {{record.addressItem.country}}<br>
                                                            </ng-container>
                                                            <span *ngIf="record.addressItem.tax_code">COD. FISC.: {{record.addressItem.tax_code}}<br></span>
                                                            <span *ngIf="record.addressItem.vat_number">P.IVA: {{record.addressItem.vat_number}}</span>
                                                        </small>
                                                    </div>
                                                    <div class="col-lg-6 border-left" *ngIf="record.addressItem.contacts && record.addressItem.contacts.length > 0">
                                                        <small>
                                                            <b>CONTATTI:</b><br>
                                                            <span *ngFor="let c of record.addressItem.contacts">{{c.value}}<br></span>
                                                        </small>
                                                    </div>
                                                </div>
                                            </small>
                                            <div class="icon"><i class="fa fa-user"></i></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-lg-12">
                                    <div class="form-group">
                                        <label>Titolo</label>
                                        <div class="input-group" >
                                            <input class="form-control form-control-sm" type="text" name="title" [(ngModel)]="record.title"  />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-lg-12">
                                    <div class="form-group">
                                        <label>Descrizione</label>
                                        <div class="input-group" >
                                            <textarea class="form-control form-control-sm" name="description" [(ngModel)]="record.description" ></textarea>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-lg-12">
                                    <label>Operatore principale</label>
                                    <div class="input-group">
                                        <input type="text" class="form-control form-control-sm" readonly name="user" [(ngModel)]="record.username">
                                        <div class="input-group-append" *ngIf="user.isAdmin()">
                                            <button class="btn btn-sm" (click)="searchUser();"  title="Associa utente"><i class="fa fa-user-tie"></i></button>
                                            <button *ngIf="record.id_user>0" class="btn text-danger btn-sm" (click)="unlinkUser()" title="Disassocia utente">
                                                <i class="fa fa-unlink"></i>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <small *ngIf="!record.id"><hr class="mt-4"><i class="text-warning fa fa-2x fa-exclamation-circle mr-2"></i>Salva per poter procedere con l'immisione degli altri dati.</small>
                        </form>
                    </div>
        
                    <!-- CRONOLOGIA -->
                    <div class="tab-pane fade show active" *ngIf="tab==1">
                        <div class="row">
                            <div class="col-12" style="max-height:80vh; overflow-y: auto;">
                                <table class="table table-sm">
                                    <thead>
                                        <th>Data e ora</th>
                                        <th>Fase</th>
                                        <th class="text-center">Stato</th>
                                        <th class="text-center">Utente</th>
                                        <th>Annotazioni</th>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let l of record.log;let i=index">
                                            <td>{{l.date | date:"dd/MM/yyyy hh:mm:ss"}}</td>
                                            <td>{{l.title}}</td>
                                            <td class="text-center">
                                                <!-- <span class="badge badge-light w-100" *ngIf="l.state==0">da avviare</span>
                                                <span class="badge badge-warning w-100" *ngIf="l.state==1">in corso</span>
                                                <span class="badge badge-primary w-100" *ngIf="l.state==2">completata</span>
                                                <span class="badge badge-danger w-100" *ngIf="l.state==3">annullata</span>
                                                <span class="badge badge-success w-100" *ngIf="l.state==4">verificata</span> -->
                                                <i [title]="'da avviare'" *ngIf="l.state==0 || l.state==null" class="text-gray fa fa-exclamation-circle"></i>
                                                <i [title]="'in corso'"  *ngIf="l.state==1" class="text-warning far fa-clock" ></i>
                                                <i [title]="'completata'" *ngIf="l.state==2" class="text-primary fa fa-check"></i>
                                                <i [title]="'annullata'" *ngIf="l.state==3"  class="text-danger fa fa-times"></i>
                                                <i [title]="'verificata'" *ngIf="l.state==4" class="text-success fa fa-check-double"></i>
                                            </td>
                                            <td class="text-center">{{l.username}}</td>
                                            <td style="max-width:100px;">
                                              <small  title="Doppio Click per modificare" style="cursor: pointer;" (dblclick)="l['editNote']=true;" *ngIf="!l['editNote']">{{l.note?l.note:'---'}}</small>
                                              <div *ngIf="l['editNote']" class="input-group input-group-sm">
                                                  <input   type="text" class="form-control form-control-sm" name="{{i}}_note" [(ngModel)]="l.note">
                                                  <div  class="input-group-append">
                                                      <button class="btn btn-success" (click)="l['editNote']=false;updateLog(l);"><i class="fa fa-check"></i></button>
                                                  </div>
                                              </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>            
                    </div>
        
                    <!-- OPERATORI -->
                    <div class="tab-pane fade show active" *ngIf="tab==6">
                        <div class="row">
                            <div class="col-12" style="max-height:80vh; overflow-y: auto;">
                                <table class="table table-sm">
                                    <thead>
                                        <th>Operatori</th>
                                        <!--<th>Permessi</th>-->
                                        <th></th>
                                    </thead>
                                    <tbody>
                                        <ng-container *ngFor="let u of record.users;let i=index">
                                            <tr *ngIf="u.show || user.isSuperUser()">
                                                <!-- <tr> -->
                                                <td>
                                                    <select class="form-control form-control-sm" name="user_{{i}}"  [(ngModel)]="u.id_user">
                                                        <option *ngFor="let u2 of users" [ngValue]="u2.id">{{u2.name}} ({{u2.grouptitle}})</option>
                                                    </select>
                                                </td>
                                                <!--<td>{{u.permissions}}</td>-->
                                                <td class="text-right"><button type="button" class="btn btn-danger" (click)="deleteUser(u)" title="Cancella"><i class="fa fa-times"></i></button></td>
                                            </tr>
                                        </ng-container>
                                    </tbody>
                                </table>
                                <button class="btn btn-outline-success btn-sm" (click)="addUser()"><i class="fa fa-plus mr-1"></i>Aggiungi operatore</button>
                                <div *ngIf="user.isSuperUser()" class="mt-2 text-xs">Sei SU, quindi puoi vedere tutti gli operatori!</div>
                            </div>
                        </div>
                    </div>
        
                    <!-- ALLARMI -->
                    <div class="tab-pane fade show active" *ngIf="tab==2">
                        <div class="row">
                            <div class="col-12">
                                <div *ngIf="!record.errors || record.errors.length==0" class="m-5 text-center text-secondary">
                                    <i class="icon fas fa-info-circle mr-2"></i><i>Nessun allarme da visualizzare</i>
                                </div>
                                <table class="table" *ngIf="record.errors && record.errors.length>0">
                                    <thead>
                                        <th>Data e Ora</th>
                                        <th>Tipologia</th>
                                        <th>Messaggio</th>
                                        <th></th>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let e of record.errors">
                                            <td>{{e.date | date:"dd/MM/yyyy"}}</td>
                                            <td>{{e.type}}</td>
                                            <td>{{e.message}}</td>
                                            <td><button type="button" class="btn btn-sm btn-danger" (click)="deleteAlarm(e)"><i class="fa fa-trash"></i></button></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>   
                    </div>            
                    
                    <!-- SCADENZARIO -->
                    <div class="tab-pane fade show active" *ngIf="tab==7">
                        <app-deadlines [default_filterdate]="100" [id_table]="record.id" [table]="'dossier'"  [reference]="record" [no_dateend]="false" [mode]="'embedded'" [viewMode]="'table'" *ngIf="id != 0"></app-deadlines>
                    </div>
        
                    <!--FILES-->
                    <div class="tab-pane fade show active" *ngIf="tab==3">
                    <!--<div class="tab-pane fade" id="tabDossier3" role="tabpanel" aria-labelledby="tabDossier3-tab">-->
                        <app-files [files]="record.files" [directory]="'dossier/'+id"></app-files>
                    </div>
        
                    <!--NOTE-->
                    <div class="tab-pane fade show active" *ngIf="record.id && tab==4">
                        <app-notebox [list]="record.notes" [table]="'dossier'" [id_table]="record.id" [id_address]="record.id" *ngIf="record.id"></app-notebox>
                    </div>
        
                    <!-- DATI-->
                    <div class="tab-pane fade show active phasescontainer" *ngIf="tab==5">
                        <ng-container *ngFor="let p of record.phases;let i=index;">
                            <ng-container *ngIf="p.status==1">
                                <div class="card border mb-1" id="{{p.id}}" [class.border-secondary]="tab_phase==i" >                                
                                    <div class="card-header bg-light pointer" title="Click per espandere/comprimere" [class.font-weight-bold]="tab_phase==i" (click)="expandPhase(p.id,tab_phase,i)" >
                                        <div>
                                            <div class="float-left">
                                                {{p.title}}
                                            </div>
                                            <div class="float-right">
                                                <span class="d-none d-lg-inline-block mr-3">
                                                    <span class="text-gray" *ngIf="getPhaseStatus(p.id,p)==0">da avviare</span>
                                                    <span class="text-warning blink" *ngIf="getPhaseStatus(p.id,p)==1">in corso</span>
                                                    <span class="text-primary" *ngIf="getPhaseStatus(p.id,p)==2">completata</span>
                                                    <span class="text-danger" *ngIf="getPhaseStatus(p.id,p)==3">annullata</span>
                                                    <span class="text-success" *ngIf="getPhaseStatus(p.id,p)==4">verificata</span>
                                                </span>
                                                <i [title]="'da avviare'" *ngIf="getPhaseStatus(p.id,p)==0" class="text-gray fa fa-exclamation-circle"></i>
                                                <i [title]="'in corso'"  *ngIf="getPhaseStatus(p.id,p)==1" class="text-warning far fa-clock" ></i>
                                                <i [title]="'completata'" *ngIf="getPhaseStatus(p.id,p)==2" class="text-primary fa fa-check"></i>
                                                <i [title]="'annullata'" *ngIf="getPhaseStatus(p.id,p)==3"  class="text-danger fa fa-times"></i>
                                                <i [title]="'verificata'" *ngIf="getPhaseStatus(p.id,p)==4" class="text-success fa fa-check-double"></i>
                                            </div>
                                        </div>
                                    </div>
                                    <ng-container *ngIf="tab_phase==i">
                                        <ng-container *ngFor="let s of p.sections">
                                            <ng-container *ngIf="s.id==id_section">
                                                <div class="card-header bg-light" *ngIf="countSections(p.fields)>1">
                                                    <div class="input-group input-group-sm w-50">
                                                        <div class="input-group-prepend input-group-prepend-sm">
                                                            <button class="btn btn-sm btn-default" *ngIf="movePrevSection(id_section,p.fields,true)" (click)="movePrevSection(id_section,p.fields)">
                                                                <i  class="fa fa-chevron-left"></i>
                                                            </button>
                                                        </div>                                                            
                                                        <select class="form-control form-control-sm font-weight-bold" [(ngModel)]="id_section" (ngModelChange)="id_section=$event">
                                                            <ng-container *ngFor="let s2 of p.sections" >
                                                                <option *ngIf="s2.label!=''" [ngValue]="s2.id">{{s2.label}}
                                                                    <i *ngIf="getCompiledField(p.id,s2.id)>0"> (ancora {{getCompiledField(p.id,s2.id)}} da inserire)</i>
                                                                </option>
                                                            </ng-container>
                                                        </select>
                                                        <div class="input-group-append input-group-append-sm">
                                                            <button class="btn btn-sm btn-default" *ngIf="moveNextSection(id_section,p.fields,true)" (click)="moveNextSection(id_section,p.fields)">
                                                                <i class="fa fa-chevron-right"></i>
                                                            </button>
                                                        </div>                                                                
                                                    </div>
                                                </div>
                                                <div class="card-body">
                                                    <ng-container *ngFor="let f of s.fields">
                                                        <!--<ng-container *ngIf="checkFieldUserPermission(f)">-->
                                                            <ng-container *ngIf="checkEnableCondition(s.fields,f.condition_enable_fieldname,f.condition_fieldname_value,f.access)">                                        
                                                                <app-field  [field]="f" [record]="record" [fields]="s.fields" [phases]="record.phases"></app-field>
                                                            </ng-container>
                                                        <!--</ng-container>-->
                                                    </ng-container>
                                                </div>
                                            </ng-container>
                                        </ng-container>
                                        <div class="card-footer" [class.show]="tab_phase==i">
                                            <button class="btn btn-outline-warning ml-1 float-right" *ngIf="getPhaseStatus(p.id)==0" (click)="openModalNote(p.id,1)"><i class="far fa-clock mr-2" title="Imposta su in corso"></i>in corso</button>
                                            <button class="btn btn-outline-primary ml-1 float-right" [disabled]="getCompiledField(p.id)>0" *ngIf="getPhaseStatus(p.id)==1" (click)="openModalNote(p.id,2)" title="Imposta su confermata"><i class="fa fa-check mr-2"></i>Conferma</button>
                                            <ng-container *ngIf="!checkPermission('showOnlyDataSection')">
                                                <button class="btn btn-outline-secondary ml-1"  *ngIf="getPhaseStatus(p.id)!=3" (click)="openModalNote(p.id,3)" title="Riporta a da avviare"><i class="fa fa-times-circle mr-2"></i>Azzera</button>
                                                <button class="btn btn-outline-warning ml-1" *ngIf="getPhaseStatus(p.id)==2 || getPhaseStatus(p.id)==3" (click)="openModalNote(p.id,1)" title="Riporta a in corso"><i class="far fa-clock mr-2"></i>in corso</button>
                                                <button class="btn btn-outline-success ml-1 float-right" *ngIf="getPhaseStatus(p.id)==2" (click)="openModalNote(p.id,4)" title="Imposta su verificata e passa alla successiva"><i class="fa fa-check-double mr-2"></i>Verificata</button>
                                            </ng-container>
                                        </div>
                                    </ng-container>                 
                                </div>
                            </ng-container>
                        </ng-container>
                        
                    </div>
                </div>
            </div>
        </div>
    </div>

</app-window>
<app-toolbarmodel [autoClose]="false" [showSaveAndClose]="record.id>0" [showSaveAndPrint]="false" [model]="this" ></app-toolbarmodel>


<ng-template #modalSelectTypes>  
    <div class="modal-header">
        Seleziona la tipologia di pratica
    </div>
    <div class="modal-body">
        <ng-container *ngFor="let t of types">
            <a class="btn btn-outline-primary btn-block mb-1"  (click)="onSelectType(t.id)">
                <i class="fas fa-archive mr-2"></i>{{t.name}}
            </a>
        </ng-container>
    </div>
</ng-template>


<ng-template #modalNote>
    <div class="modal-body text-center">
        <i class="text-gray far fa-3x fa-edit p-2"></i>
        <p>Se necessario, puoi scrivere qui un'annotazione riguardante questo passaggio di stato.</p>
        <textarea type="text" rows="8" class="form-control form-control-sm" name="note" [(ngModel)]="log_note"></textarea>
    </div>
    <div class="modal-footer">
        <button class="btn btn-outline-success btn-block" (click)="confirmModalNote()">Ok</button>
        <button class="btn btn-outline-secondary btn-block" (click)="closeModalNote()">Annulla</button>
    </div>
</ng-template>